import { render, staticRenderFns } from "./NewMultipleChoice.vue?vue&type=template&id=32dfeeda&scoped=true&"
import script from "./NewMultipleChoice.vue?vue&type=script&lang=js&"
export * from "./NewMultipleChoice.vue?vue&type=script&lang=js&"
import style0 from "./NewMultipleChoice.vue?vue&type=style&index=0&id=32dfeeda&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32dfeeda",
  null
  
)

export default component.exports